export default {
    name: 'staffers',
    component: () => import(/* webpackChunkName: "staffers-layout" */ '@/modules/staffers/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.staffers.index',
            component: () => import(/* webpackChunkName: "staffers-index" */ '@/modules/staffers/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.staffers.create',
            component: () => import(/* webpackChunkName: "staffers-create" */ '@/modules/staffers/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.staffers.edit',
            component: () => import(/* webpackChunkName: "staffers-edit" */ '@/modules/staffers/views/Edit'),
        },
    ]
}